import { document } from '../globals';

export default (elementId: string): void =>
  document?.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth' });
